import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './fonts/Montserrat/Montserrat-Regular.ttf';
import './fonts/Montserrat/Montserrat-Italic.ttf';
import './fonts/Montserrat/Montserrat-Light.ttf';
import './fonts/Montserrat/Montserrat-LightItalic.ttf';
import './fonts/Montserrat/Montserrat-Medium.ttf';
import './fonts/Montserrat/Montserrat-SemiBold.ttf';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
